module.exports = __webpack_public_path__ + "logos/logo-github-enterprise.aaae2f.svg";